import {
  Banner,
  BannerAvatar,
  BannerBadge,
  BannerBody,
  BannerThumb,
  BannerTitleRow,
  LockButton,
  LockDate,
  LockRoot,
  LockTime,
} from "./ios.styles";
import {
  CameraGlyph,
  FlashlightGlyph,
  MessagesBadgeGlyph,
  PersonGlyph,
} from "./iosGlyphs";
import type { PhoneMessage } from "../phoneMessage";
import { PreviewErrorBubble } from "../PreviewErrorBubble";

function lockScreenBody(message: PhoneMessage): string {
  if (message.text) return message.text;
  if (message.imageUrl) return "Photo";
  if (message.documentName) return "Contact card";
  return "";
}

interface IosLockScreenProps {
  message: PhoneMessage;
  onRetry?: () => void;
}

export function IosLockScreen({ message, onRetry }: IosLockScreenProps) {
  return (
    <LockRoot>
      <LockDate>Tuesday, September 8</LockDate>
      <LockTime>9:41</LockTime>

      {message.isError ? (
        <Banner withThumb={false}>
          <span />
          <PreviewErrorBubble
            onRetry={onRetry}
            maxWidth={300}
            borderRadius={12}
            fontSize={15}
            lineHeight={20}
          />
        </Banner>
      ) : (
        <Banner withThumb={message.imageUrl !== null}>
          <BannerAvatar>
            <PersonGlyph size={22} />
            <BannerBadge>
              <MessagesBadgeGlyph />
            </BannerBadge>
          </BannerAvatar>
          <div>
            <BannerTitleRow>
              <b>{message.sender}</b>
              <span>now</span>
            </BannerTitleRow>
            <BannerBody data-testid="ios-lock-body">
              {lockScreenBody(message)}
            </BannerBody>
          </div>
          {message.imageUrl ? (
            <BannerThumb>
              <img src={message.imageUrl} alt={message.imageAlt} />
            </BannerThumb>
          ) : null}
        </Banner>
      )}

      <LockButton side="left">
        <FlashlightGlyph />
      </LockButton>
      <LockButton side="right">
        <CameraGlyph />
      </LockButton>
    </LockRoot>
  );
}
